import {Model} from 'vue-mc';


/**
 * IntPromotedCarouselModel model
 */

export class IntPromotedCarouselModel extends Model {

    // Default attributes that define the "empty" state.
    defaults() {
        return {
	        interpreter_promotion_id: 0,
	        first_name: '',
	        surname: 0,
	        profile: '',
	        accreditation: []
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/intPromotedCarouselModel.js